import { render, staticRenderFns } from "./ManagerDashboard.vue?vue&type=template&id=bc474e3a"
import script from "./ManagerDashboard.vue?vue&type=script&lang=js"
export * from "./ManagerDashboard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports